<template>
  <div
    class="window-item"
    :class="{even: index % 2}"
    :style="{ backgroundColor: $store.infoscreenData.infoboardBackgroundColor }"
  >
    <div
      class="window-id"
      ref="windowNumber"
      :style="{
        color: $store.infoscreenData.infoboardTicketNumberColor,
        fontSize: windowNumberFontSize + 'vw',
        fontFamily: `${$store.infoscreenData.fontBoldFamily}, ${$store.fontFamilyDefault}, sans-serif`
      }"
    >
      {{ orderNumber || ticketNumber }}
    </div>
  </div>
</template>

<script>
import TicketMixin from '../../mixins/TicketMixin';

export default {
  name: 'TicketSingleLine',
  mixins: [TicketMixin],
  props: {
    ticket: {type: Object, default: () => ({})},
    index: Number,
  },
  // TODO add proper param indication
  computed: {
    ticketNumber() {
      return `${this.ticket.prefix}${this.ticket.number}`;
    },
    orderNumber() {
      if (!this.ticket.additional_info) return undefined;

      const validInfo = Object.values(this.ticket.additional_info)[0];
      return validInfo ? validInfo.value : undefined;
    }
  },
  data() {
    return {
      defaultWindowNumberFontSize: 4.91666667,
      windowNumberFontSize: 4.91666667
    };
  },
};
</script>

<style lang="scss" scoped>
.window-id {
  font-size: 5vw;
  font-weight: 700;
  text-align: center;
}

.window-item {
  &.even {
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.1) 0%,
      rgba(0, 0, 0, 0.25) 50%,
      rgba(0, 0, 0, 0.1) 100%
    );
  }
}
</style>
